module.exports = __webpack_public_path__ + "img/citibanamex.0b828a8d.png";